import { module as BaseModule } from 'modujs';
import gsap from 'gsap';
import Swiper from 'swiper';
import { Navigation, Controller, EffectCreative, EffectFade } from 'swiper/modules';

const ANIMATION_DURATION = 1.3;

const iconStates = [
  { left: '0%', opacity: 0.0, scale: 0.5, imageY: '2rem', z: 0 },
  { left: '50%', opacity: 1.0, scale: 1.0, imageY: '0rem', z: 1 },
  { left: '100%', opacity: 0.0, scale: 0.5, imageY: '0rem', z: 1 },
];

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.events = {
      click: {
        quizTrigger: 'openQuiz',
      },
    };

    this.counter = 0;
    this.timeoutID = null;
    this.interval = this.getData('interval');
  }

  init() {
    // setup initial state
    //gsap.set( this.$('solution')[0].children[1], { y: '1.5rem' } );
    //gsap.set( this.$('solution')[1], { opacity: 1, scale: 0.5 } );
    //gsap.set( this.$('solution')[2], { opacity: 1, scale: 0.5 } );

    this.initializeSliders();
  }

  initializeSliders() {
    this.sliderSolutions = new Swiper(this.$('slider')[1], {
      modules: [EffectFade],
      speed: ANIMATION_DURATION,
      loop: true,
      allowTouchMove: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      slidesPerView: 1,
      on: {
        init: (slider) => {
          const overviews = document.querySelectorAll('.c-overview');
          overviews.forEach((elem, index) => {
            //console.log( elem );
            slider.slides[index].appendChild(elem);
          });
          //console.log( slider );
          //this.runAnimation();
        }
      }
    });

    this.sliderImages = new Swiper(this.$('slider')[0], {
      modules: [Navigation, Controller, EffectCreative],
      speed: 800,
      slidesPerView: 1,
      loop: true,
      navigation: {
        prevEl: '.c-solutions_navigation_prev',
        nextEl: '.c-solutions_navigation_next',
      },
      controller: {
        control: [
          this.sliderSolutions
        ]
      },
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          translate: [-300, 0, -500], // experiment 1
          origin: 'top center',
        },
        next: {
          opacity: 0,
          translate: [300, 0, -500], // experiment 1
          origin: 'bottom center',
        },
      },
      on: {
        //init: swiper => {
        //  setTimeout(() => {
        //    swiper.el.classList.add('slider-images-visible');
        //  }, 300);
        //},
      },
      limitProgress: 1,
      progressMultiplier: 1200,
      //shadowPerProgress: true,
    });
  }

  openQuiz() {
    this.call('open', 'generic', 'Quiz');
  }

  runAnimation() {
    //gsap.fromTo(this.$('progress')[0], {
    //  '--progress': '0%'
    //}, {
    //  '--progress': '100%',
    //  duration: this.interval,
    //  ease: 'linear',
    //});

    const easing = 'power2.inOut';

    //
    // SOLUTION GO
    //
    const goIndex = (this.counter + 1) % 3;
    gsap.set(this.$('solution')[0], { zIndex: iconStates[goIndex].z });
    gsap.to(this.$('solution')[0], {
      duration: ANIMATION_DURATION,
      ease: easing,
      left: iconStates[goIndex].left,
      scale: iconStates[goIndex].scale,
    });

    gsap.to(this.$('solution')[0].children[1], {
      duration: goIndex === 1 ? ANIMATION_DURATION * 0.4 : ANIMATION_DURATION * 0.2,
      ease: 'power1.out',
      delay: goIndex === 1 ? ANIMATION_DURATION : 0,
      opacity: iconStates[goIndex].opacity,
      y: iconStates[goIndex].imageY,
    });

    //
    // SOLUTION FLY
    //
    const flyIndex = this.counter % 3;
    gsap.set(this.$('solution')[1], { zIndex: iconStates[flyIndex].z });
    gsap.to(this.$('solution')[1], {
      duration: ANIMATION_DURATION,
      ease: easing,
      left: iconStates[flyIndex].left,
      scale: iconStates[flyIndex].scale,
    });

    gsap.to(this.$('solution')[1].children[1], {
      duration: flyIndex === 1 ? ANIMATION_DURATION * 0.4 : ANIMATION_DURATION * 0.2,
      delay: flyIndex === 1 ? ANIMATION_DURATION : 0,
      opacity: iconStates[flyIndex].opacity,
      y: iconStates[flyIndex].imageY,
    })

    //
    // SOLUTION BE //oculto las caracteristicas de la solucion BE
    //
    // const beIndex = ( this.counter + 2 ) % 3;
    //    gsap.set(this.$('solution')[2], { zIndex: iconStates[ beIndex ].z });
    //    gsap.to(this.$('solution')[2], {
    //      duration: ANIMATION_DURATION,
    //      ease: easing,
    //      left: iconStates[ beIndex ].left,
    //      scale: iconStates[ beIndex ].scale,
    //    });
    //
    //    gsap.to(this.$('solution')[2].children[1], {
    //      duration: beIndex === 1 ? ANIMATION_DURATION * 0.4 : ANIMATION_DURATION * 0.2,
    //      delay: beIndex === 1 ? ANIMATION_DURATION : 0,
    //      opacity: iconStates[ beIndex ].opacity,
    //      y: iconStates[ beIndex ].imageY,
    //    });
    //
    //    // Update text slider with current graphic
    //    this.$('slider')[0].swiper.slideTo( (this.counter % 3), ANIMATION_DURATION * 1000 );
    //
    //    this.counter++;
    //    this.timeoutID = setTimeout( () => this.runAnimation(), this.interval * 1000 );
    //  }
  }
}
